import { render, staticRenderFns } from "./addOrEditIntegral.vue?vue&type=template&id=337cbf80"
import script from "./addOrEditIntegral.vue?vue&type=script&lang=js"
export * from "./addOrEditIntegral.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports